export default __webpack_public_path__ + "static/media/2Vid.8b8c1a91.mp4";